import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly STORAGE_KEY = 'app_language';
  private currentLanguageSubject: BehaviorSubject<string>;
  public currentLanguage$: Observable<string>;

  constructor(private translateService: TranslateService) {
    // Obtener idioma guardado o usar el predeterminado
    const savedLang = localStorage.getItem(this.STORAGE_KEY);
    const initialLang = savedLang || this.translateService.defaultLang || 'es';

    // Establecer el idioma en TranslateService
    this.translateService.use(initialLang);

    this.currentLanguageSubject = new BehaviorSubject<string>(initialLang);
    this.currentLanguage$ = this.currentLanguageSubject.asObservable();
  }

  getCurrentLanguage(): string {
    return this.currentLanguageSubject.value;
  }

  changeLanguage(lang: string): void {
    this.translateService.use(lang);
    localStorage.setItem(this.STORAGE_KEY, lang); // Persistir el idioma
    this.currentLanguageSubject.next(lang);
  }

  toggleLanguage(): void {
    const currentLang = this.getCurrentLanguage();
    const newLang = currentLang === 'es' ? 'en' : 'es';
    this.changeLanguage(newLang);
  }
}
